export const firebaseConfig = {
  apiKey: 'AIzaSyBYqE3G7trdUgMz9Iu62d_zbwcAKXEKMDY',
  authDomain: 'yoloworks-vcc-dev.firebaseapp.com',
  projectId: 'yoloworks-vcc-dev',
  storageBucket: 'yoloworks-vcc-dev.appspot.com',
  messagingSenderId: '1049588283835',
  appId: '1:1049588283835:web:e517f0bed3b36a12986c9e',
};
